import React from 'react';

import '../my-courses.css';
import API from "../../utils/api";
import {serrializer} from "../../utils/utils";
import Preloader from "../../utils/preloader";
import CoursePreview from "../../course-snippets/preview/v3";

class Favourites extends React.Component {
    constructor (props) {
        super();
        this.state = {
            loading: true,
            courses: [],
            loadedLength: 0,
            no_favourites: false
        };

        this.delete = this.delete.bind(this);
    }

    loadProgress = () => {
      const { courses } = this.state;

      courses.forEach(course => {
        API.get('/whub/v3/progress/' + course.id)
          .then(r => {
            const lessons = r.data;

            course.lessons.forEach(lesson => {
              lesson.studyStatus = lessons[lesson.id].status;
            })
            this.setState(courses);
          });
      })
    }

    loadCourses = () => {
        const t = this;
        let ids = t.props.userData.favourites;

        if (ids.constructor && ids.constructor.name === 'Object') {
          ids = Object.values(ids);
        }

        if (!ids || !ids.length) {
            t.setState({loading: false, no_favourites: true});
        }
        else {
            API.get('/whub/v3/course?' + serrializer({include: ids, per_page: 50}))
                .then(function (r) {
                    const totalFound = r.data.total;
                    const data = r.data.results;

                    t.setState({loading: false, courses: data, loadedLength: totalFound}, function() {this.loadProgress()});
                })
                .catch(function (error) {
                    console.log(error);
                });
        }


    };

    checkAuth = () => {
        const p = this.props;

        if (!p.authorized) {
            alert('пользователь не авторизован!');
        }
        else {
            if (this.props.userData.favourites) {
                this.loadCourses();
            }
            else {
                this.setState({loading: false, no_courses: true});
            }
        }
    };

    delete(id){
        this.setState(prevState => ({
            courses: prevState.courses.filter(el => el !== id ),
            loadedLength: prevState.loadedLength -1,
            no_courses: !(prevState.loadedLength -1)
        }));
    }

    componentDidMount() {
        // document.body.classList.add('no_search');
        this.checkAuth();
    };
    componentWillUnmount() {
        // document.body.classList.remove('no_search');
    };

    render() {
        const coursesData = this.state.courses;
        const preloader = this.state.loading ? <Preloader/> : '';
        const courses = coursesData.map((course, idx) =>
            <CoursePreview deleteFunc={this.delete.bind(this, course)} itemData={course} itemId={idx} key={course.id} linkType="favourite" />
        );
        const noFavouritesText = this.state.no_favourites ? <p className="no_courses">В избранном пока пусто...</p> : '';

        return (
            <div className="profile_courses_list">
                <div className="courses_block">
                    {courses}
                    {noFavouritesText}
                </div>
                {preloader}
            </div>
        );
    }
}

export default Favourites;